import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StorageService } from '../services/storage.service';
import { RequestParams } from './request-params';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor(
    private readonly http: HttpClient,
    private readonly storage: StorageService
  ) {}

  get(): RequestParams {
    return new RequestParams('GET', (p) => this.execute(p));
  }

  post(): RequestParams {
    return new RequestParams('POST', (p) => this.execute(p));
  }

  put(): RequestParams {
    return new RequestParams('PUT', (p) => this.execute(p));
  }

  delete(): RequestParams {
    return new RequestParams('DELETE', (p) => this.execute(p));
  }

  execute<T = any>(params: RequestParams): Observable<T> {
    let headers = new HttpHeaders(params.customHeaders);
    let query = new HttpParams();

    if (params.authenticated) {
      const token = this.storage.get('access_token') ?? '';
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    for (const [key, value] of Object.entries(params.queryParams)) {
      if (value != null && typeof value !== 'object') {
        query = query.set(key, String(value));
      }
    }

    let body: unknown;
    if (params.filePayload) {
      body = params.filePayload;
    } else if (params.requestPayload !== undefined) {
      body = JSON.stringify(params.requestPayload);
      headers = headers.set('Content-Type', 'application/json');
    }

    return this.http.request(params.method, params.resolvedUrl, {
      body,
      headers,
      params: query,
      responseType: params.responseTypeValue,
      observe: params.observeValue,
    } as any) as Observable<T>;
  }
}
